<h1 mat-dialog-title="">User Detail</h1>
<div mat-dialog-content>
    <p>{{ data.email }}</p>
    <form [formGroup]="form">
        <mat-form-field appearance="fill">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" />
        </mat-form-field>
    </form>
</div>
<div mat-dialog-actions>
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button mat-stroked-button color="primary" (click)="save()">Save</button>
</div>
